import type IAttendanceRecord from '@src/models/interfaces/attendanceRecord.interface';

import type { ReplacementCellSource } from './isReplacementCell';
import { isReplacementCell } from './isReplacementCell';

export const matchesWorkJourneyConfig = (
  record: IAttendanceRecord,
  workJourneyConfigId?: string | null,
): boolean => {
  if (!workJourneyConfigId) return true;
  return record.workJourneyConfigId === workJourneyConfigId;
};

/**
 * Picks the record to show in the matrix attendance drawer: the one belonging to
 * the journey being reviewed, falling back to the substitute's own journey record
 * when the cell is a coverage cell. That original-journey record is the marking
 * surface; its work journey, shift, and config are not replaced.
 */
export const selectMatrixAttendanceRecord = (
  records: IAttendanceRecord[],
  options: {
    workJourneyConfigId?: string | null;
    cell?: ReplacementCellSource | null;
  },
): IAttendanceRecord | null => {
  const ownJourneyRecord = records.find(record =>
    matchesWorkJourneyConfig(record, options.workJourneyConfigId),
  );

  if (ownJourneyRecord) {
    return ownJourneyRecord;
  }

  return isReplacementCell(options.cell) ? records[0] ?? null : null;
};
